var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(true)?_c('keep-alive',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.imgUrl}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }